import React from 'react'

interface Props {
  outerColor: string
  innerColor: string
}

export const OfferIcon = ({ outerColor, innerColor }: Props) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20'>
      <path
        fill={outerColor}
        d='M11.053 1.06a.79.79 0 0 0-1.106 0L8.805 2.176a.79.79 0 0 1-.75.201L6.509 1.98a.79.79 0 0 0-.958.553l-.429 1.54a.79.79 0 0 1-.549.548l-1.539.43a.79.79 0 0 0-.553.957l.398 1.548a.79.79 0 0 1-.201.75L1.56 9.446a.79.79 0 0 0 0 1.107l1.118 1.141a.79.79 0 0 1 .2.75l-.397 1.547a.79.79 0 0 0 .553.958l1.54.43a.79.79 0 0 1 .548.549l.43 1.538a.79.79 0 0 0 .957.553l1.548-.397a.79.79 0 0 1 .75.2l1.14 1.119a.79.79 0 0 0 1.107 0l1.141-1.118a.79.79 0 0 1 .75-.201l1.547.398a.79.79 0 0 0 .958-.553l.43-1.54a.79.79 0 0 1 .548-.548l1.54-.43a.79.79 0 0 0 .552-.957l-.397-1.548a.79.79 0 0 1 .2-.75l1.119-1.141a.79.79 0 0 0 0-1.106l-1.119-1.141a.79.79 0 0 1-.2-.75l.397-1.548a.79.79 0 0 0-.553-.957l-1.539-.43a.79.79 0 0 1-.549-.549l-.429-1.539a.79.79 0 0 0-.958-.553l-1.547.398a.79.79 0 0 1-.75-.2z'
      />
      <path
        fill={innerColor}
        d='M6.35 9.077a4.149 4.149 0 0 1 8.297 0c0 1.438-.803 2.473-1.626 3.33-.199.207-.404.408-.601.603l-.026.025c-.208.205-.408.402-.596.6-.378.399-.687.78-.887 1.18a.461.461 0 0 1-.825 0c-.2-.4-.509-.781-.887-1.18a25 25 0 0 0-.596-.6l-.025-.025c-.198-.195-.403-.396-.601-.603-.823-.857-1.627-1.892-1.627-3.33'
      />
      <path fill={outerColor} d='M10.5 10.23a1.383 1.383 0 1 0 0-2.765 1.383 1.383 0 0 0 0 2.765' />
    </svg>
  )
}
